/* eslint-disable prettier/prettier */
import React from 'react'

interface AdviceTextItemProps {
    text: string,
    name: string,
    color: string,
    showerror: any
}

const AdviceText = ({ text, name, color, showerror }: AdviceTextItemProps) => {
    return showerror ? (
        <div data-name={name} className={'cypress--advice-text'} style={{ color: `${color}`, fontSize: '0.688em' }}>
            {text}
        </div>
    ) : null
}

export default AdviceText
